import React, { useState } from 'react';
import { userRoleTypes } from '../utils/userRoleTypes';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../data/atoms/utilsAtoms';
import MyAccountManageSubscriptionModal from '../component/My Account/MyAccountManageSubscriptionModal';

export const UpgradeButton = () => {
    const userData = useAtomValue(userInfoAtom);
    const [modalOpen, setModalOpen] = useState(false);
    const [activeAction, setActiveAction] = useState('plan');
    
    const isPlanStandard = userData.subscriptionId &&
		(userData?.role?.toLowerCase() !== userRoleTypes?.ADMIN) && 
						(!userData?.user?.userType)

    if(!isPlanStandard){
        return null
    }

	return (
		<>
			<button
				onClick={() => {
					setActiveAction('plan');
					setModalOpen(true);
				}}
				style={{
					padding: '4px 6px',
					borderRadius: '6px',
					background: '#008BC3',
					color: '#ffff',
					fontFamily: 'Good Times',
					fontSize: '10px',
					fontWeight: 600,
					lineHeight: '16px',
					letterSpacing: '2px',
					marginRight: '4px',
					border: 'none',
					cursor: 'pointer'
				}}
			>
				UPGRADE
			</button>
			<MyAccountManageSubscriptionModal
				open={modalOpen}
				onClose={() => setModalOpen(false)}
				initialAction={activeAction}
			/>
		</>
	);
};
